export default class Newsletter {
	constructor(elm) {
        this.elm = elm;

		this.title = this.elm.querySelector('[data-newsletter-title]');
		this.text = this.elm.querySelector('[data-newsletter-text]');
		this.form = this.elm.querySelector('[data-newsletter-form]');
		this.form.addEventListener('submit', this.submit.bind(this));
	}

	submit(e) {
		e.preventDefault();

		if (this.isSubmitting) {
			return;
		}

		this.isSubmitting = true;

		fetch(this.form.action, {
			method: 'POST',
			body: new FormData(this.form),
		})
			.then((response) => response.json())
			.then((data) => this.displaySuccess(data))
			.catch((error) => this.displayFailure(error))
			.finally(() => (this.isSubmitting = false));
	}

	displaySuccess(data) {
		if (!data.success) {
			this.displayFailure(data.data.message);
			return;
		}

		this.title.innerHTML = data.data.title;
		this.text.innerHTML = data.data.message;
		this.form.remove();
	}

	displayFailure(error) {
		console.error('Error:', error);

		this.title.innerHTML = 'Oops';
		this.text.innerHTML = data.data.message;
		this.form.remove();
	}
}
